import { IconButton, PlusIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SmsTemplateListHeaderProps = {
  onCreate: () => void;
  isCreateDisabled?: boolean;
};

export const SmsTemplateListHeader: FC<SmsTemplateListHeaderProps> = ({ onCreate, isCreateDisabled }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
      <div className='space-y-1'>
        <h2 className='text-4xl font-semibold tracking-tight text-slate-900'>{t('smsWorkspace.templates.templateListTitle')}</h2>
        <p className='text-secondary-600 max-w-2xl text-sm'>{t('smsWorkspace.templates.templateListDescription')}</p>
      </div>
      <IconButton
        leadingIcon={<PlusIcon className='size-5 text-white-100' />}
        className='inline-flex w-full max-w-[211px] justify-center capitalize'
        onClick={onCreate}
        disabled={isCreateDisabled}
        text={t('smsWorkspace.templates.createButton')}
      />
    </div>
  );
};
